import { ListScreen } from '@rahtab/stack-navigator';
import { withSeparator } from '@rahtab/system/lib/tools/string';
import { Colors, getSpacing, ItemCard, ListEmpty, Picker, Tag, Text, TextView } from '@rahtab/ui';
import MerchandiseListEmptyIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/StoreMerchandises';
import SortIcon from '@rahtab/ui/dist/icons/SortIcon';
import { StackScreenProps } from '@react-navigation/stack';
import { useMerchandiseInventory } from 'hooks/InventoryHooks/useMerchandiseInventory';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { RootStackType } from '../../Router';
type MerchandiseInventoryProps = StackScreenProps<RootStackType, 'MerchandiseInventory'>;
const defaultMerchandise = require('../../../assets/images/defaultMerchandise.png');

const MerchandiseInventory: FC<MerchandiseInventoryProps> = ({ route: { params } }) => {
  const { id: categoryId } = params;
  const { called, data, loading, refetch } = useMerchandiseInventory(categoryId);
  return (
    <ListScreen
      title="موجودی کالا"
      loading={loading}
      data={data.productInfo}
      listData={data.merchandiseInventoryList || []}
      refreshing={called && loading}
      onRefresh={refetch}
      renderControls={({ name, imageUrl, merchandiseCount, activeLoadCount }) => {
        return (
          <>
            <ItemCard image={imageUrl} inHeader title={name} hasChevron={false} imageProps={{ variant: 'default' }}>
              <Text color="description" margin="none">
                تعداد بارهای فعال: <Text>{activeLoadCount}</Text>
              </Text>
            </ItemCard>
            <View style={styles.rowView}>
              <TextView
                title="تعداد کالاها"
                value={merchandiseCount}
                isSpaceBetween
                style={styles.textView}
                marginBottom={0}
              />
              <Picker
                selectedValue="highAmount"
                color="primary"
                marginBottom={0}
                variant="outlined"
                customIcon={<SortIcon fill={Colors.primary} />}
                style={styles.picker}>
                <Picker.Item label="بیشترین موجودی" value="highAmount" />
              </Picker>
            </View>
          </>
        );
      }}
      ListEmptyComponent={<ListEmpty text="کالایی یافت نشد." imageComponent={<MerchandiseListEmptyIcon />} />}
      keyExtractor={({ id }) => id}
      renderItem={({ item: { id, imageUrl, name, status, statusText, loadCount, unitText, remainingQuantity } }) => {
        const isItemActive = status === 1;
        return (
          <ItemCard
            title={name}
            image={imageUrl}
            defaultImage={defaultMerchandise}
            statusBadge={
              <Tag
                text={statusText}
                backgroundColor={isItemActive ? 'green' : 'default'}
                color={isItemActive ? 'white' : 'disabled'}
              />
            }
            screenName={'LoadsList'}
            params={{ merchandiseId: id }}
            caption={
              <Text color="primary" margin="none">
                مشاهده بارهای موجود از کالا
              </Text>
            }>
            <Text color="description">
              تعداد بارها: <Text>{loadCount}</Text>
            </Text>
            <Text color="description" margin="none">
              موجودی کالا:{' '}
              <Text>{remainingQuantity !== 0 ? `${withSeparator(remainingQuantity)} ${unitText}` : 'ناموجود'}</Text>
            </Text>
          </ItemCard>
        );
      }}
    />
  );
};

export default MerchandiseInventory;

const styles = StyleSheet.create({
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: getSpacing(),
  },
  textView: {
    flex: 1,
    marginRight: getSpacing(),
  },
  picker: {
    flex: 2,
  },
});
